import { initTemplateEditor } from "src/froala_template_editor";

var playbooks = {
  initialize: function () {
    $(".campaign-template-form").each(function (i, form) {
      $(form)
        .find(".new-category-input")
        .keypress(function (e) {
          var k = e.keyCode || e.which;
          if (k == 13) {
            e.preventDefault();
            $(form).find(".new-category-submit").click();
          }
        });

      $(form)
        .find(".new-category-submit")
        .on("click", function () {
          var category = $(form).find(".new-category-input").val();
          var dropdown = $(form).find('select[name="playbook[categories][]"]');

          if (
            $(dropdown).find('option[value="' + category + '"]').length == 0
          ) {
            $(dropdown).append(
              '<option value="' +
                category +
                '" selected>' +
                category +
                "</option>"
            );
          }

          $(form).find(".new-category-input").val("");
        });

      $(form)
        .find(".new-industry-input")
        .keypress(function (e) {
          var k = e.keyCode || e.which;
          if (k == 13) {
            e.preventDefault();
            $(form).find(".new-industry-submit").click();
          }
        });

      $(form)
        .find(".new-industry-submit")
        .on("click", function () {
          var industry = $(form).find(".new-industry-input").val();
          var dropdown = $(form).find('select[name="playbook[industries][]"]');

          if (
            $(dropdown).find('option[value="' + industry + '"]').length == 0
          ) {
            $(dropdown).append(
              '<option value="' +
                industry +
                '" selected>' +
                industry +
                "</option>"
            );
          }

          $(form).find(".new-industry-input").val("");
        });

      $(".campaign-template-form").each(function (i, form_div) {
        $(form_div)
          .find("textarea")
          .each(function (j, textarea) {
            initTemplateEditor(textarea, {
              toolbarButtons: [
                "paragraphFormat",
                "fontSize",
                "lineHeight",
                "insertLink",
                "bold",
                "italic",
                "underline",
                "strikeThrough",
                "align",
                "formatUL",
                "insertImage",
                "clearFormatting",
              ],
            });
          });
      });

      $(".template-header").on("click", function () {
        $(this).find(".glyphicon").toggleClass("glyphicon-chevron-right");
        $(this).find(".glyphicon").toggleClass("glyphicon-chevron-down");
        $(this).parent().find(".template-body").toggle();
      });
    });
  },
};

document.addEventListener("turbolinks:load", function () {
  if (
    $("body").attr("data-controller") == "playbooks" ||
    ($("body").attr("data-controller") == "cta" &&
      ["templates", "new"].includes($("body").attr("data-action")))
  ) {
    playbooks.initialize();

    $(".cta-type-select").on("click", function (e) {
      var ctaTypeDiv = $(e.target).closest(".cta-type-select");
      var cta_type = $(ctaTypeDiv).find("input").val();
      $('input[type="hidden"][name="cta_type"]').val(cta_type);
      $("#template-search").submit();
    });

    $(".template-category-select").on("click", function (e) {
      var categoryDiv = $(e.target).closest(".template-category-select");
      var category = $(categoryDiv).find("input").val();
      $('input[type="hidden"][name="category"]').val(category);
      $('input[type="hidden"][name="my_templates"]').val("");
      $("#template-search").submit();
    });

    $(".template-industry-select").on("click", function (e) {
      var industryDiv = $(e.target).closest(".template-industry-select");
      $(".template-industry-select input[type='checkbox']:checked").each(
        function (i, checkbox) {
          $(checkbox).prop("checked", false);
        }
      );

      var checkbox = $(industryDiv).find("input[type='checkbox']");
      $(checkbox).prop("checked", true);

      var category = $(checkbox).val();
      $('input[type="hidden"][name="industry"]').val(category);
      $('input[type="hidden"][name="my_templates"]').val("");
      $("#template-search").submit();
    });

    $(".premium-select").on("click", function (e) {
      var premiumDiv = $(e.target).closest(".premium-select");
      var premium = $(premiumDiv).find("input").val();
      $('input[type="hidden"][name="premium"]').val(premium);
      $('input[type="hidden"][name="my_templates"]').val("");
      $("#template-search").submit();
    });

    $(".my-templates-select").on("click", function () {
      $('input[type="hidden"][name="my_templates"]').val("true");
      $('input[type="hidden"][name="premium"]').val("");
      $('input[type="hidden"][name="category"]').val("");
      $('input[type="hidden"][name="industry"]').val("");
      $("#template-search").submit();
    });

    function togglePanel(playbook_div) {
      $(playbook_div).toggleClass("collapsed");
    }

    $(".campaign-playbook-trigger").on("click", function () {
      if ($(".campaign-playbook-panel").hasClass("collapsed")) {
        $(".campaign-playbook-panel").removeClass("collapsed");
      } else {
        $(".campaign-playbook-panel").addClass("collapsed");
        setTimeout(function () {
          $(".campaign-playbook-panel").removeClass("collapsed");
        }, 200);
      }
    });
  }
});

export default playbooks;
